import {
  PREFLIGHT_MARKET_KINDS,
  type PreflightMarketKind,
} from "@nexus/contracts";

type MarketLike = { kind: PreflightMarketKind; name: string };

/** Catalogue kind order (Global → continent → country), then name within a kind. */
export function compareMarketsByKindThenName(a: MarketLike, b: MarketLike): number {
  const kindDelta =
    PREFLIGHT_MARKET_KINDS.indexOf(a.kind) - PREFLIGHT_MARKET_KINDS.indexOf(b.kind);
  if (kindDelta !== 0) return kindDelta;
  return a.name.localeCompare(b.name);
}

export function sortMarketsByKindThenName<T extends MarketLike>(markets: T[]): T[] {
  return [...markets].sort(compareMarketsByKindThenName);
}

/**
 * Group markets in catalogue kind order, skipping empty kinds. Global stays
 * unlabelled in the picker (one row); continents and countries get section headings.
 */
export function groupMarketsByKind<T extends MarketLike>(
  markets: T[],
): { kind: PreflightMarketKind; markets: T[] }[] {
  const sorted = sortMarketsByKindThenName(markets);
  return PREFLIGHT_MARKET_KINDS.flatMap((kind) => {
    const items = sorted.filter((market) => market.kind === kind);
    return items.length > 0 ? [{ kind, markets: items }] : [];
  });
}
